module.exports = __webpack_public_path__ + "media/img/only_city_bcg-e5e0d881.png";